
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__getValidation, FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, LoginInformation, FormState_$reflection, ClientApiResponse$1_$reflection, LoginInformation_$reflection } from "../Shared/Shared.js";
import { record_type, lambda_type, unit_type, union_type, class_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Requests_UserWithoutLoginToUserWithLoginDto, Requests_UserWithoutLoginToUserWithLoginDto_$reflection } from "../Shared/User.js";
import { Cmd_successToast, Cmd_errorToast } from "../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ErrorAlert } from "../Components/Alert.js";
import { RadioButton } from "../Components/RadioButton.js";
import { Input } from "../Components/Input.js";
import { unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../Components/Dialog.js";
import { TextButton } from "../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetLoginInformation", "UpdateUserTypeResponse", "UpdateUserType", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Receiver.TransformUserWithoutLoginToUserWithLoginDialog.Msg", [], Msg, () => [[["Item", LoginInformation_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", class_type("System.Exception")]]]);
}

function putUpdateUserEmailOrPhoneNumberCmd(dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), ["/api/receivers/employee-to-user", toString(0, Auto_generateBoxedEncoder_437914C6(Requests_UserWithoutLoginToUserWithLoginDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(3, [Item_1])));
}

class State extends Record {
    constructor(Dto, SuccessCallback, OnClose, FormState) {
        super();
        this.Dto = Dto;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Receiver.TransformUserWithoutLoginToUserWithLoginDialog.State", [], State, () => [["Dto", Requests_UserWithoutLoginToUserWithLoginDto_$reflection()], ["SuccessCallback", lambda_type(string_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()]]);
}

function init(employee, successCallback, onClose) {
    return [new State(new Requests_UserWithoutLoginToUserWithLoginDto(employee.Id, new LoginInformation(0, [""])), successCallback, onClose, FormState_get_empty()), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Dto, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Dto, state.SuccessCallback, state.OnClose, FormState_get_empty()), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback(response.fields[0]);
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("user.change_user_type_success_msg")]))];
            }
        }
        case 2:
            return [new State(state.Dto, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState)), putUpdateUserEmailOrPhoneNumberCmd(state.Dto)];
        case 3:
            return [state, Cmd_none()];
        default:
            return [new State(new Requests_UserWithoutLoginToUserWithLoginDto(state.Dto.UserId, msg.fields[0]), state.SuccessCallback, state.OnClose, state.FormState), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_1 = toList(delay(() => {
        let matchValue;
        return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
            Label: matchValue,
        }))), delay(() => {
            let elems;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [RadioButton({
                ComponentState: props.ComponentState,
                Label: t(t("user.login_with_email")),
                OnSelect: (_arg) => {
                    props.Dispatch(new Msg(0, [new LoginInformation(0, [""])]));
                },
                Selected: props.Dto.LoginInformation.tag === 0,
            }), RadioButton({
                ComponentState: props.ComponentState,
                Label: t(t("user.login_with_phone_number")),
                OnSelect: (_arg_1) => {
                    props.Dispatch(new Msg(0, [new LoginInformation(1, [""])]));
                },
                Selected: props.Dto.LoginInformation.tag === 1,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                const matchValue_3 = props.Dto.LoginInformation;
                return (matchValue_3.tag === 0) ? singleton(createElement(Input, {
                    ComponentState: props.ComponentState,
                    Label: "E-Mail",
                    OnChange: (v_1) => {
                        props.Dispatch(new Msg(0, [new LoginInformation(0, [v_1])]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                    Value: matchValue_3.fields[0],
                })) : singleton(createElement(Input, {
                    ComponentState: props.ComponentState,
                    Label: t("user.phone_number"),
                    OnChange: (v) => {
                        props.Dispatch(new Msg(0, [new LoginInformation(1, [v])]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "phoneNumber")),
                    Value: matchValue_3.fields[0],
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ChangeUserWithoutLoginToUserWithLoginDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Employee, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("user.change_user_type"), {
        Body: singleton_1(createElement(DialogBody, {
            ComponentState: componentState,
            Dispatch: dispatch,
            Dto: state_1.Dto,
            FormState: state_1.FormState,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-change-user-type-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(2, []));
            },
            TestId: "save-change-user-type-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

